import Vue from 'vue'
import Router from 'vue-router'
import { getAccessToken } from '@/utils'

// 修复vue-router Unhandled promise rejection NavigationDuplicated 问题
// https://github.com/vuejs/vue-router/issues/2932
// fix star
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
// fix end

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./views/home.vue'),
    meta: {
      title: '商城首页 - 纵购商城'
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('./views/register.vue'),
    meta: {
      title: '卖家注册 - 纵购商城'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login.vue'),
    meta: {
      title: '卖家登录 - 纵购商城'
    }
  },
  {
    path: '/password/reset',
    name: 'reset-password',
    component: () => import('./views/reset-password.vue'),
    meta: {
      title: '忘记密码重置 - 纵购商城'
    }
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('./views/join.vue'),
    meta: {
      title: '入驻流程 - 纵购商城'
    }
  }
]

const router = new Router({
  mode: 'history',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  if (!getAccessToken()) {
    if (to.name === 'join') {
      router.replace('/login?from=join')
    }
  } else {
    if (to.name === 'login' || to.name === 'register') {
      router.replace(`/`)
    }
  }

  document.title = to.meta.title

  next()
})

export default router
